// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/style.less
 ** module id = 4
 ** module chunks = 0
 **/